package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.pages.ProfilePageUIState
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_APP_LANGUAGE
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.expected.getLanguage
import com.example.mystybag.core.expected.getVersionName
import com.example.mystybag.core.expected.LocaleHelper
import com.example.mystybag.core.extensions.addDownloadLink
import com.example.mystybag.core.extensions.formatNames
import com.example.mystybag.core.extensions.ifNotEmpty
import com.example.mystybag.core.extensions.separate
import com.example.mystybag.core.helpers.GlobalCommonData.getFirstNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.getLastNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.getNumberOfReservationsValue
import com.example.mystybag.core.helpers.GlobalCommonData.getSavedAmountValue
import com.example.mystybag.core.helpers.GlobalCommonData.getUserImgUrlValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.core.model.IconDescription
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p36
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.sharedmodels.ModelsData
import com.example.mystybag.common.logic.DialogNavigatorStandard
import com.example.mystybag.logoutUtils.helpers.LogoutMethods.deleteAppDataAndGoToEntryScreen
import com.example.mystybag.login.logic.NavigatorFeatureLoginAndRegistration
import kotlinx.coroutines.launch

class ProfilePageViewModel(context: AppContext): ChildViewModel<ProfilePageUIState>(context, ProfilePageUIState()) {

    override fun onCreate() {
        navControls.title = sharedString(SR.strings.profile)
        loadProfileData()
    }

    override fun onResume() {
        super.onResume()
        loadProfileData()
    }

    /** Презарежда метриките от глобалните потребителски данни (напр. след синхронизация след платена резервация). */
    fun refreshProfileStats() {
        loadProfileData()
    }

    private fun loadProfileData() {
        val firstName = getFirstNameValue()
        val lastName = getLastNameValue()
        val userImgUrl = getUserImgUrlValue()
        val numberOfReservations = getNumberOfReservationsValue()
        val savedAmount = getSavedAmountValue()
        val currentLanguage = getLanguage()

        val appVersion = getVersionName().ifEmpty { "1.0.0" }
        updateState { state ->
            state.copy(
                firstName = firstName,
                lastName = lastName,
                userImgUrl = userImgUrl,
                numberOfReservations = numberOfReservations,
                savedAmount = savedAmount,
                userImage = ImageDescription(
                    link = userImgUrl.ifNotEmpty { it.addDownloadLink() },
                    icon = IconDescription(
                        resource = SRC.images.avatar_fill_icon,
                        imageSize = p36
                    )
                ),
                userName = firstName.separate(lastName).formatNames(),
                currentLanguage = currentLanguage,
                appVersion = appVersion
            )
        }
    }

    fun changeLanguage(language: String) {
        Preferences.setString(PREFERENCES_APP_LANGUAGE, language)
        ModelsData.language = language
        LocaleHelper.updateLocaleAndShortcuts(language)
        updateState { it.copy(currentLanguage = language) }
        // Reload profile data to update UI with new language
        loadProfileData()
    }
    
    fun logout() {
        // Clear all preferences and app data
        deleteAppDataAndGoToEntryScreen("")
        
        // Navigate to Welcome screen via main stack
        scope.launch {
            setResult<MainCallback> {
                popToMainAndNavigate(NavigatorFeatureLoginAndRegistration())
            }
        }
    }

    fun onLogOutClick() {
        scope.launch {
            showDialog(
                DialogNavigatorStandard(
                    title = sharedString(SR.strings.log_out),
                    message = sharedString(SR.strings.are_you_sure_you_want_to_proceed),
                    positiveTitle = sharedString(SR.strings.log_out_yes),
                    negativeTitle = sharedString(SR.strings.cancel),
                    stackedButtons = true
                )
            ).onPositiveClick {
                logout()
            }
        }
    }

    fun onProfileClick() {
        navigate(com.example.mystybag.appCore.logic.NavigatorPersonalDetails)
    }

    fun onNotificationsClick() {
        navigate(com.example.mystybag.appCore.logic.NavigatorNotificationSettings)
    }
    fun onPaymentMethodsClick() {
        navigate(com.example.mystybag.appCore.logic.NavigatorStoredCards)
    }
    fun onSettingsClick() {
        navigate(com.example.mystybag.appCore.logic.NavigatorSettings)
    }
    fun onHelpCenterClick() {
        navigate(com.example.mystybag.appCore.logic.NavigatorContacts)
    }
    fun onAboutMystyBagClick() {}
    fun onTermsOfUseClick() {}
    fun onPrivacyPolicyClick() {}
}

